import React, { useState } from "react"

import { accordionType } from "../../utils/Constant"
import AccordionPanel from "../AccordianPanel"

const Accordion = ({ data, type, callbackData, displayComponent, roleAndPermissionPage }) => {
    const currentActiveId = JSON.parse(sessionStorage.getItem("currentActiveMenuId")) || 1
    const [activeId, setActiveId] = useState(accordionType === type ? 0 : currentActiveId)    
    const sortedSideNav = [...data].sort((a, b) => (a.title||a.module_name).localeCompare((b.title||b.module_name)))
    return (
        <div className="w-[100%]">
            { sortedSideNav?.map((item) => (
                <AccordionPanel
                    key={ item.id }
                    id={ accordionType === type ? item.module_id : item.id }
                    type={ type }
                    activeId={ activeId }
                    setActiveId={ setActiveId }
                    title={ accordionType === type ? item?.module_name : item?.title }
                    subMenuItems={ accordionType === type ? item?.sub_modules : item?.subMenu }
                    path={ item.path }
                    data={ sortedSideNav }
                    callbackData={ callbackData }
                    displayComponent={ displayComponent }
                    roleAndPermissionPage={ roleAndPermissionPage }
                    irisModule={ item }
                ></AccordionPanel>
            )) }
        </div>
    )
}

export default Accordion
